import React, { memo } from 'react';
import _ from 'lodash';
import ReactEcharts, { EChartsOption } from 'echarts-for-react';
import HrCard from 'routes/HumanResourcesModule/components/HrCard';
import { DEFAULT_OPTIONS } from 'routes/HumanResourcesModule/components/HrChart/eChartHelpers';
import NoData from 'routes/HumanResourcesModule/components/HrDataGrid/NoData';
import { GRID_DEFAULT_HEIGHT } from 'routes/HumanResourcesModule/components/ui/constants';
import LoadingBarChart from './LoadingBarChart';

type Props = {
    title: string;
    infoTooltip?: string;
    isLoading: boolean;
    options: EChartsOption;
    cardHeaderActions?: React.ReactNode;
    titleNode?: React.ReactNode;
};

const HrChart = ({
    title,
    infoTooltip,
    isLoading,
    options,
    cardHeaderActions,
    titleNode,
}: Props): React.ReactElement => {
    const echartOptions = {
        ...DEFAULT_OPTIONS,
        ...options,
    };
    return (
        <HrCard
            title={title}
            infoTooltip={infoTooltip}
            cardHeaderActions={cardHeaderActions}
            titleNode={titleNode}
        >
            {/* the height is the same as the aggrid default one so that the
        container does not change when passing from table to graph */}
            {isLoading ? (
                <LoadingBarChart />
            ) : (
                <>
                    {options.xAxis.data.length === 0 ? (
                        <NoData />
                    ) : (
                        <ReactEcharts
                            option={echartOptions}
                            style={{ height: GRID_DEFAULT_HEIGHT }}
                            notMerge
                        />
                    )}
                </>
            )}
        </HrCard>
    );
};

export default memo(HrChart, _.isEqual);
